import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import Page from '@src/components/page';
import PageSwiper from '@src/components/swiper/page-swiper';
import SilentVideo from '@src/components/silent-video';
import Indicator from './components/indicator';
import Store from './store';
import ComponentFooter from '@src/business-components/common-footer';
import BackTopFooter from '@src/business-components/backtop-footer';
import { px2rem2 } from '@src/utils/rem-util';

const styles = require('./index.less');

const WorldView = ({ store }) => {
  store.use();

  const videoPage = () => {
    return (
      <ul>
        {store.videoList.map((item, idx) => {
          return (
            <li key={idx} className={cx(store.videoIndex === idx && styles.active)} onClick={() => store?.changeVideo(idx)}>
              <span className={styles.number}>{item?.numTitle}</span>
              <h3 className={styles.title}>{item?.chTitle}</h3>
              {/* <span className={styles.enTitle}>{item?.enTitle}</span> */}
              <div className={styles.desc}>
                <div>{item?.wordDesc}</div>
              </div>
            </li>
          );
        })}
      </ul>
    );
  };
  const swiper = () => {
    return (
      <div className={styles.swiper}>
        <PageSwiper key={store.slidesData.length} store={store?.pageSwiperStore}>
          {store.slidesData.map((slide, index) => {
            if (slide.isVideo === '1') {
              return (
                <div key={index} className={cx(styles.slide, styles.videoSlide)}>
                  <SilentVideo ref={store.videoRef} className={styles.video} src={store.videoSrc} loop={false} />
                  <div className={styles.infoBg}>
                    <div className={styles.btnPlay} onClick={store.playVideo}>
                      <span className={styles.btnPlayLayer} />
                    </div>
                  </div>
                  <div className={styles.activeVideoFrame} style={{ '--x': `${px2rem2(372 * store.videoIndex)}rem` }} />
                  {videoPage()}
                </div>
              );
            }
            return (
              <div key={index} className={styles.slide}>
                <div className={styles.kv} style={{ backgroundImage: `url(${slide.worldImg})` }} />
                <div className={styles.infoBg}>
                  <span className={styles.deco} />
                </div>
                <div className={styles.info}>
                  <div className={styles.title}>
                    <h3>{slide.chTitle}</h3>
                    {/* <span className={styles.enTitle}>{slide.enTitle}</span> */}
                  </div>
                  <div className={styles.desc}>
                    <div className={styles.descInner}>{slide.wordDesc}</div>
                  </div>
                </div>
              </div>
            );
          })}
        </PageSwiper>
      </div>
    );
  };

  let indicatorActiveIndex = store.pageSwiperStore.baseSwiperStore.activeIndex;
  if (indicatorActiveIndex >= store.slidesData?.length) {
    indicatorActiveIndex = store.slidesData?.length - 1;
  }

  return (
    <Page className={cx(styles.worldRoot, 'page-main')}>
      <div className={styles.content}>
        <Indicator
          config={store.slidesData?.map(i => i.chTitle)}
          activeIndex={indicatorActiveIndex}
          onChange={store.pageSwiperStore.baseSwiperStore.onChange}
        />
        {swiper()}
        {/* 底栏 */}
        <BackTopFooter btns={['scrollDownTip', 'backTop']} showBtnBackTop={store.isShowBackTop} onBackTop={store.backTop} position="fixed" theme="light" />
        <ComponentFooter store={store.comFooterStore} />
      </div>
    </Page>
  );
};

export default wrapStore(WorldView, Store);
